export default __webpack_public_path__ + "static/media/480_dummy2016-tattoo01-de.47a54854.png";